import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../dailyIntakeAction';
import fetchApi from "./fetchApi";

function fetchDailyIntakeAction() {
  return fetchApi('/v1/fc_api/daily_intake_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchDailyIntakeAction;
